import React from "react";
export default function BrandBadge({ color = "#5BC5F2", children, className = "" }) {
  return (
    <span className={`chip ${className}`} style={{ background: color + "22", color, border: `1px solid ${color}55` }}>
      {children}
    </span>
  );
}
